import { render, staticRenderFns } from "./StaffReferralCode.vue?vue&type=template&id=178a4794&scoped=true&"
import script from "./StaffReferralCode.vue?vue&type=script&lang=js&"
export * from "./StaffReferralCode.vue?vue&type=script&lang=js&"
import style0 from "./StaffReferralCode.vue?vue&type=style&index=0&id=178a4794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a4794",
  null
  
)

export default component.exports